import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-activate-account',
  templateUrl: './activate-account.component.html',
  styleUrls: ['./activate-account.component.scss']
})
export class ActivateAccountComponent implements OnInit {
  public submitted = false;
  public succeed = false;
  public passwordMatch = true;
  public password: string;
  public confirmPassword: string;

  private _mailToken: string;

  constructor(private _authService: AuthService, private _route: ActivatedRoute, private _router: Router) { }

  ngOnInit() {
    this._mailToken = this._route.snapshot.queryParams.token;
    console.log('lel', this._mailToken);
  }

  public onSubmit() {
    if (this.password !== this.confirmPassword) {
      this.passwordMatch = false;
    } else if (this.password === this.confirmPassword) {
      this.submitted = true;
      this._authService.putPassword(this._mailToken, this.password).subscribe(() => {
        this.succeed = true;
      }, () => {
        this.submitted = false;
      });
    }
  }
}
